import script from "./BaseTypography.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseTypography.vue?vue&type=script&lang=ts&setup=true"

import "./BaseTypography.vue?vue&type=style&index=0&id=22f385db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22f385db"]])

export default __exports__